import { usePublishingContext } from "../../../../contexts/PublishingContext.js";
import { getFileMetadataFromUrl } from "../../utils/get-file-metadata-from-url.js";
import { resolveFileName } from "../../utils/resolve-file-name.js";
/* empty css          */
import { ImageThumbnail } from "../../../../components/ImageThumbnail/index.js";
import { FileTag } from "./components/FileTag.js";
import { ImageThumbnailWithNameAndDate } from "../../../../components/ImageThumbnail/ImageThumbnailWithNameAndDate.js";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Icon, Skeleton, downloadFile, useLightboxContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { MdError } from "react-icons/md";
// src/modules/Files/components/FileDisplayCard/index.tsx
var FileDisplayCard = React.memo(({ fileUrl, orientation }) => {
	const [name, setName] = useState("");
	const [type, setType] = useState();
	const [loading, setLoading] = useState(true);
	const local = useRef({ retriesLeft: 3 });
	const [error, setError] = useState(false);
	const [lastModified, setLastModified] = useState();
	const lightboxContext = useLightboxContext();
	const publishingContext = usePublishingContext();
	const loadFile = useCallback((fileUrl) => {
		setError(false);
		if (fileUrl.includes("s3")) {
			const { abortPromise, promise } = getFileMetadataFromUrl(fileUrl);
			local.current.abortPromise = abortPromise;
			promise.then((response) => {
				if (response) {
					const { name, type } = response;
					setType(type);
					if (name) setName(name);
					setLastModified(response.modifiedDate);
					setLoading(false);
				} else {
					console.warn("getFileMetadataFromUrl() failed, need to retry");
					throw new Error("getFileMetadataFromUrl() failed, need to retry");
				}
			}).catch((err) => {
				console.warn("<FileDisplayCard /> getFileMetadataFromUrl() err, retrying", fileUrl, err);
				setLoading(true);
				if (local.current.retriesLeft) local.current.timeout = setTimeout(() => {
					local.current.retriesLeft--;
					loadFile(fileUrl);
				}, 2e3);
				if (!local.current.retriesLeft) {
					setLoading(false);
					setError(true);
				}
			});
		}
	}, []);
	useEffect(() => {
		if (fileUrl) loadFile(fileUrl);
		return () => {
			local.current?.abortPromise?.();
			clearTimeout(local.current.timeout);
		};
	}, [fileUrl]);
	const handleClick = (e) => {
		e.stopPropagation();
		if (type && !publishingContext?.isPublishing && lightboxContext?.onClickFile && [
			"image",
			"pdf",
			"video"
		].some((fileType) => type.includes(fileType))) lightboxContext.onClickFile(fileUrl);
		else downloadFile({ src: fileUrl }, { resolveFileName }).catch((err) => {
			console.warn("<FileDisplayCard /> download failed", fileUrl, err);
		});
	};
	if (error) return /* @__PURE__ */ jsx("div", {
		className: "text-color-critical h-12 w-12 rounded",
		children: /* @__PURE__ */ jsx("div", {
			className: "inline-flex h-full w-full items-center justify-center",
			children: /* @__PURE__ */ jsx(Icon, { Icon: MdError })
		})
	});
	if (loading) return /* @__PURE__ */ jsx("div", {
		className: "h-12 w-12 rounded",
		onClick: handleClick,
		children: /* @__PURE__ */ jsx(Skeleton, { fillContainer: true })
	});
	if (orientation === "vertical") {
		if (publishingContext?.isPublishing) return /* @__PURE__ */ jsx("a", {
			href: fileUrl,
			target: "_blank",
			rel: "noreferrer",
			children: /* @__PURE__ */ jsx(ImageThumbnailWithNameAndDate, {
				fileUrl,
				timestamp: lastModified,
				name
			})
		});
		else return /* @__PURE__ */ jsx(ImageThumbnailWithNameAndDate, {
			fileUrl,
			timestamp: lastModified,
			name,
			onClick: handleClick
		});
	}
	if (type?.includes("image")) {
		if (publishingContext?.isPublishing) return /* @__PURE__ */ jsx("a", {
			href: fileUrl,
			target: "_blank",
			rel: "noreferrer",
			children: /* @__PURE__ */ jsx(ImageThumbnail, { src: fileUrl })
		});
		else return /* @__PURE__ */ jsx(ImageThumbnail, {
			src: fileUrl,
			onClick: handleClick
		});
	}
	if (publishingContext?.isPublishing) return /* @__PURE__ */ jsx("a", {
		href: fileUrl,
		target: "_blank",
		rel: "noreferrer",
		children: /* @__PURE__ */ jsx(FileTag, {
			name: name || fileUrl,
			type
		})
	});
	return /* @__PURE__ */ jsx(FileTag, {
		name: name || fileUrl,
		onClick: handleClick,
		type
	});
});
export { FileDisplayCard };

//# sourceMappingURL=index.js.map